import { isStage } from '@config/environment';

const TC_SCRIPT_7_URL = 'https://cdn.tagcommander.com/310/tc_Vestiairecollective_7.js';
const TC_SCRIPT_1_URL = 'https://cdn.tagcommander.com/310/tc_Vestiairecollective_1.js';
export const TC_SCRIPT_7_ID = 'tc_script_7';
export const TC_SCRIPT_1_ID = 'tc_script_1';

const loadTrackingScripts = (
  setIsTcEvents1Loaded: Function,
  setIsTcEvents7Loaded: Function,
  event7LoadCallback: Function,
  event1LoadCallback: Function,
) => {
  setIsTcEvents7Loaded(false);

  const scriptEltTcScript7 = document.createElement('script');
  scriptEltTcScript7.id = TC_SCRIPT_7_ID;
  scriptEltTcScript7.type = 'text/javascript';
  scriptEltTcScript7.src = `${TC_SCRIPT_7_URL}?ts=${Date.now()}`;
  scriptEltTcScript7.onload = () => {
    event7LoadCallback();
  };
  scriptEltTcScript7.async = true;
  scriptEltTcScript7.defer = false;
  if (isStage) {
    scriptEltTcScript7.crossOrigin = 'anonymous';
  }
  (document.getElementsByTagName('head')[0] || document.getElementsByTagName('script')[0].parentNode).insertBefore(
    scriptEltTcScript7,
    null,
  );

  if (!document.getElementById(TC_SCRIPT_1_ID)) {
    setIsTcEvents1Loaded(false);

    const scriptEltTcScript1 = document.createElement('script');
    scriptEltTcScript1.id = TC_SCRIPT_1_ID;
    scriptEltTcScript1.type = 'text/javascript';
    scriptEltTcScript1.src = `${TC_SCRIPT_1_URL}?ts=${Date.now()}`;
    scriptEltTcScript1.onload = () => {
      event1LoadCallback();
    };
    scriptEltTcScript1.async = true;
    scriptEltTcScript1.defer = false;
    if (isStage) {
      scriptEltTcScript1.crossOrigin = 'anonymous';
    }
    (document.getElementsByTagName('head')[0] || document.getElementsByTagName('script')[0].parentNode).insertBefore(
      scriptEltTcScript1,
      null,
    );
  }
};

export default loadTrackingScripts;
